import {
  LOOKUP_ENUMS_FETCH,
  LOOKUP_SPECIES_FETCH,
} from '../actions';

const INIT_STATE = {
  enums: {},
  species: [],
};

export default function lookupReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case LOOKUP_ENUMS_FETCH.SUCCESS:
      return { ...state, enums: action.payload };
    case LOOKUP_SPECIES_FETCH.SUCCESS:
      return { ...state, species: action.payload };
    default:
      return state;
  }
}
